class FittingSettingCollection {
    id: string;

    defaultHeight: string;

    defaultZ: string;

    heightList: HTMLElement;

    /**
     * コンストラクタ
     */
    constructor() {
      console.log('FittingSettingCollection');
    }
}
export default FittingSettingCollection;
